/**
 * @desc 测试订单发起退款
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, body: defs.walmart.OrderRefundRequest, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrderReturns/testRefund/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
